module.exports = __webpack_public_path__ + "static/manageTeam@2x-5cf893217e09130265878b3fafc32ec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/collaboration/manageTeam@2x.jpg
// module id = 2581
// module chunks = 168707334958949